import { get } from "lodash-es";

export default {
  name: "ErrorMessage",
  bind: resolve,
  componentUpdated: resolve
};

function resolve(element, { value, arg }) {
  if (shouldShowErrorMessage(value, arg)) {
    showErrorMessage(element);
  } else {
    hideErrorMessage(element);
  }
}

function shouldShowErrorMessage(value, arg) {
  if (arg != null) {
    return !get(value, arg, true) && value.$dirty;
  }

  return value.$anyError && value.$dirty;
}

function showErrorMessage(element) {
  element.style.display = "block";
}

function hideErrorMessage(element) {
  element.style.display = "none";
}
